export default [
  {
    path: '/internal-audit',
    name: 'internal-audit',
    component: () => import('@/views/internal-audit/InternalAudit.vue'),
    meta: {
      title: 'Internal Audit',
      requiresAuth: true,
      action: 'browes',
      resource: 'Internal Audit',
      pageTitle: 'Internal Audit',
      breadcrumb: [
        {
          text: 'Internal Audit',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/internal-audit/add',
    name: 'add-internal-audit',
    component: () => import(
      '@/views/internal-audit/control-internal-audit/AddEditInternalAudit.vue'
    ),
    meta: {
      title: 'Add Internal Audit ',
      requiresAuth: true,
      action: 'create',
      resource: 'Internal Audit',
      pageTitle: 'Internal Audit',
      breadcrumb: [
        {
          text: 'Internal Audit',
          to: '/internal-audit',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/internal-audit/edit/:id',
    name: 'edit-internal-audit',
    component: () => import(
      '@/views/internal-audit/control-internal-audit/AddEditInternalAudit.vue'
    ),
    meta: {
      title: 'Edit Internal Audit ',
      requiresAuth: true,
      pageTitle: 'Internal Audit',
      breadcrumb: [
        {
          text: 'Internal Audit',
          to: '/internal-audit',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
